/**
 * Pitch convention for this isolated laboratory: 0 = horizon, positive = up,
 * negative = down. A positive result means the feature is above the current
 * viewing centre.
 */
export function calculateRelativeVerticalAngle(
  elevationAngleDegrees: number,
  pitchDegrees: number,
): number {
  if (!Number.isFinite(elevationAngleDegrees) || !Number.isFinite(pitchDegrees)) {
    throw new RangeError("elevationAngleDegrees and pitchDegrees must be finite numbers.");
  }
  return elevationAngleDegrees - pitchDegrees;
}
